<template>
  <div>
    <base-info ref="baseInfo" v-model="form" v-loading="loading" :new-contract="newContract" />
    <div v-loading="loading" class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file v-if="form.id" :contract-num="form.id" />
      </div>
    </div>
    <product-list ref="product" v-loading="productLoading" :rebate-amount="form.rebateAmount" :communication-order-discount="form.communicationOrderDiscount" :sales-type="form.salesType" :rebate="form.rebate" :contract-type="form.contractType" :form="form" @chooseAddress="(val)=>{form.receiptAddressId=val.id}" />
    <div class="rj-page-card">
      <div class="rj-page-card__content">
        <el-button type="primary" :loading="loading" @click="submit(0)">
          发布合同
        </el-button>
        <el-button type="default" :loading="loading" @click="submit(1)">
          保存草稿
        </el-button>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
// import productList from '../productList';
import productList from './productList/index.vue';
import contractFile from '../../../Chief/contract/common/contractFile';
import axios, { saveOrderContractInfo, getContractDetailAllInfoByConNum, getContractProductInfoByContractId, getReceiptAddressByContractId } from '@/API';
import { buildContractComplianceRequest, checkExportCompliance } from '@/libs/exportCompliance';
export default {
  data () {
    return {
      newContract: 'newContract',
      form: {
        paymentMethodName: '立即'
      },
      loading: false,
      productLoading: false
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    baseInfo,
    productList,
    contractFile
  },
  computed: {},
  methods: {
    initData () {
      this.loading = true;
      getContractDetailAllInfoByConNum(this.contractNum).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.form = json.data;
          this.form.paymentMethodName = '立即';
          this.$nextTick(() => {
            this.$refs.baseInfo.setInitData();
            this.initProduct();
          });
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    initProduct () {
      this.productLoading = true;
      axios.all([
        getContractProductInfoByContractId(this.form.id, this.form.contractType, true, (this.form.departmentCode || '').startsWith('000062'), this.form.contractNum),
        getReceiptAddressByContractId(this.form.id)
      ]).then((res) => {
        let fjson = res[0].data;
        let sjson = res[1].data;
        this.productLoading = false;
        this.form.authorizationEmail = res[0].data.data[0].authorizationEmail ? res[0].data.data[0].authorizationEmail : '';
        if (fjson.status === '200') {
          fjson.data.forEach((row, index) => {
            let totalBak = 0;
            fjson.data.forEach((one) => {
              if (one.id === row.id) {
                totalBak += one.productNum;
              }
            });
            row.productNumBak = totalBak;
          });
          this.$refs.product.productList = fjson.data;
        }
        if (sjson.status === '200') {
          this.$refs.product.address = sjson.data;
        }
      }).catch(() => {
        this.productLoading = false;
      });
    },
    async submit (val) {
      let baseR = true;
      let Product = {};
      if (!val) {
        baseR = await this.$refs.baseInfo.validate();
        baseR.contractInfo.isDraft = false;
      } else {
        baseR = this.$refs.baseInfo.validatedrafts();
        baseR.contractInfo.isDraft = true;
      }
      if (val) {
        Product = await this.$refs.product.validateDraft();
      } else {
        Product = await this.$refs.product.validate();
      }

      if (baseR && Product) {
        val ? baseR.contractInfo.isDraft = true : baseR.contractInfo.isDraft = false;

        Product.productList.forEach((item) => {
          item.authorizationEmail = baseR.contractDetail.authorizationEmail;
        });

        let contractDetail = {
          actualSettlementAmount: Product.actualSettlementAmount,
          orderSales: Product.orderSales,
          productServiceProviderA: this.form.productServiceProviderA,
          productServiceProviderB: this.form.productServiceProviderB,
          productServiceProviderC: this.form.productServiceProviderC,
          serviceSubjectName: this.form.serviceSubjectName
        };
        baseR.invoiceEmail = this.$refs.baseInfo.form.invoiceEmail; // 电票邮箱字段
        baseR.contractDetail = { ...baseR.contractDetail, ...contractDetail };

        this.loading = true;
        if (!val) {
          const decision = await checkExportCompliance(this,
            buildContractComplianceRequest(this.form, baseR, Product.productList, this.$refs.product.address));
          if (!decision.allowBusiness) {
            this.loading = false;
            return;
          }
        }
        saveOrderContractInfo({ ...baseR, contractProductInfos: Product.productList }).then((res) => {
          let json = res.data;
          this.loading = false;
          if (json.status === '200') {
            if (val) {
              this.$router.replace({ name: 'orderPersionDrafts' });
            } else {
              this.$router.replace({ name: 'orderPersionContractList' });
            }
          }
        }).catch(() => {
          this.loading = false;
        });
      }
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
